/* eslint-disable max-classes-per-file */
import { UnsupportedBitcoinAddressError } from "@orangekit/sdk";
export class OrangeKitBitcoinWalletConnectionError extends Error {
    constructor(walletName, cause) {
        super(`Failed to connect ${walletName} Bitcoin wallet`, { cause });
    }
}
export class WalletNetworkDoesNotMatchProviderChainError extends Error {
    constructor() {
        const message = "Wallet network does not match provider id. Make sure you use proper network in your wallet.";
        super(message);
    }
}
export function isUnsupportedBitcoinAddressError(error) {
    return error instanceof UnsupportedBitcoinAddressError;
}
export function isWalletNetworkDoesNotMatchProviderChainError(error) {
    return error instanceof WalletNetworkDoesNotMatchProviderChainError;
}
//# sourceMappingURL=errors.js.map